import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  Close
} from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { i18n } from "../../../translate/i18n";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#FFF5F5",
        padding: "8px",
        borderRadius: "8px",
        width: "200px",
        border: "1px solid rgba(239, 68, 68, 0.25)",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px"
      }}
    >
      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex"
        }}
      >
        <Close
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#ef4444"
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>
          {i18n.t("flowBuilder.nodes.closeTicket.name")}
        </div>
      </div>
      <div style={{ color: "#727272", fontSize: "12px" }}>
        {i18n.t("flowBuilder.nodes.closeTicket.description")}
      </div>
      
      <div
        style={{
          position: "absolute",
          right: "8px",
          top: "8px",
          display: "flex",
          gap: "4px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{
            width: "12px",
            height: "12px",
            color: "#727272",
            cursor: "pointer"
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{
            width: "12px",
            height: "12px",
            color: "#727272",
            cursor: "pointer"
          }}
        />
      </div>

      <Handle
        type="target"
        position="left"
        id="b"
        style={{ top: 10 }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
